import * as React from 'react';
import type { SVGProps } from 'react';
const SvgPptxGlyph = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    viewBox="0 0 12 12"
    fill="none"
    {...props}
  >
    <path
      d="M10.2439 7.5C10.4098 7.03083 10.5 6.52595 10.5 6C10.5 3.51472 8.48528 1.5 6 1.5C3.51472 1.5 1.5 3.51472 1.5 6C1.5 8.48528 3.51472 10.5 6 10.5C7.95933 10.5 9.62619 9.24779 10.2439 7.5ZM6 1.5V6L10.2439 7.5"
      stroke="#fff"
      strokeLinejoin="round"
    />
  </svg>
);
export default SvgPptxGlyph;
